import { HTMLAttributes, ReactNode } from "react";
import clsx from "clsx";
import S from "./index.module.scss";

interface ContainerProps extends HTMLAttributes<HTMLDivElement> {
  children: ReactNode;
}

const Container = ({ children, className, ...props }: ContainerProps) => {
  return (
    <div className={clsx(S.container, className)} {...props}>
      {children}
    </div>
  );
};

export default Container;
